var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('user-menu'),_vm._v(" "),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('dashboard.sidebar.dashboard'),
          icon: 'dashboard'
        }}},[(_vm.getMyCurrentCenter)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('dashboard.sidebar.progress_activity_title'),
            path: _vm.localePath('dashboard-activity'),
            prefix: 'Activity'
          }}}):_vm._e(),_vm._v(" "),(_vm.getMyCurrentCenter)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('dashboard.sidebar.progress_seo_global'),
            path: _vm.localePath('dashboard-seo-global'),
            prefix: 'Activity'
          }}}):_vm._e()],1),_vm._v(" "),(_vm.getMyCurrentCenter)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.community.title'),
          icon: 'people'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.account.my_teacher'),
            path: _vm.localePath('account-teacher'),
            prefix: 'Teacher'
          }}}),_vm._v(" "),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.center.team'),
            path: _vm.localePath('center-team'),
            prefix: 'teams'
          }}}),_vm._v(" "),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.center.place'),
            path: _vm.localePath('center-places'),
            prefix: 'places'
          }}})],1):_vm._e(),_vm._v(" "),(_vm.getMyCurrentCenter)?_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.center.activities'), icon: 'date_range' }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.center.service'),
            path: _vm.localePath('activity-services'),
            prefix: 'services'
          }}}),_vm._v(" "),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.center.sessions_to_come'),
            path: _vm.localePath('activity-sessions-to-come'),
            prefix: 'sessions'
          }}}),_vm._v(" "),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.center.sessions_history'),
            path: _vm.localePath('activity-sessions-history'),
            prefix: 'sessions'
          }}})],1):_vm._e(),_vm._v(" "),(_vm.getMyCurrentCenter)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.center.finances'),
          icon: 'euro'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.center.ewallet'),
            path: _vm.localePath('finance-ewallet'),
            prefix: 'ewallet'
          }}}),_vm._v(" "),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.center.cash_desk'),
            path: _vm.localePath('finance-desk'),
            prefix: 'cash_desk'
          }}})],1):_vm._e(),_vm._v(" "),(_vm.getMyCurrentCenter)?_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.marketing.title'), icon: 'timeline' }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.website.title'),
            path: _vm.localePath('marketing-my_site'),
            prefix: 'my-site'
          }}}),_vm._v(" "),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.blog.title'),
            path: _vm.localePath('marketing-my_blog'),
            prefix: 'my-blog'
          }}})],1):_vm._e()],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }